import {
    SIM_PROVIDER_ACCOUNT_CREATE_EDIT_OPEN_MODAL,
    SIM_PROVIDER_ACCOUNT_CREATE_REQUEST,
    SIM_PROVIDER_ACCOUNT_CREATE_RESULT,
    SIM_PROVIDER_ACCOUNT_EDIT_REQUEST,
    SIM_PROVIDER_ACCOUNT_EDIT_RESULT,
    SIM_PROVIDER_ACCOUNT_GET_REQUEST,
    SIM_PROVIDER_ACCOUNT_GET_RESULT,
} from 'Redux/actionTypes';

export const simProviderAccountCreateEditOpenModal = (open, data) => ({
    type: SIM_PROVIDER_ACCOUNT_CREATE_EDIT_OPEN_MODAL,
    payload: { open, data }
})

export const simProviderAccountCreateRequest = (data) => ({
    type: SIM_PROVIDER_ACCOUNT_CREATE_REQUEST,
    payload: data
})

export const simProviderAccountCreateResult = (result) => ({
    type: SIM_PROVIDER_ACCOUNT_CREATE_RESULT,
    payload: result
})

export const simProviderAccountEditRequest = (data) => ({
    type: SIM_PROVIDER_ACCOUNT_EDIT_REQUEST,
    payload: data
})

export const simProviderAccountEditResult = (result) => ({
    type: SIM_PROVIDER_ACCOUNT_EDIT_RESULT,
    payload: result
})

export const simProviderAccountGetRequest = (data) => ({
    type: SIM_PROVIDER_ACCOUNT_GET_REQUEST,
    payload: data
})

export const simProviderAccountGetResult = (result) => ({
    type: SIM_PROVIDER_ACCOUNT_GET_RESULT,
    payload: result
})